import axiosInstance from "../lib/axios.instance";
import type { TextTemplate } from "../types/knowledgeBank.types";

const BASE_URL = "/templates";

export const getTemplates = async (): Promise<TextTemplate[]> => {
  const response = await axiosInstance.get<TextTemplate[]>(`${BASE_URL}/`);
  return response.data;
};
